import AXIOS from '@/utils/$axios';

export const getOrganizationList = payload =>
    AXIOS.post(`/space/enterprise/organization/ent/list`, payload);

export const addEnt = payload =>
    AXIOS.post(`/space/enterprise/organization/ent/add-ent`, payload);

export const deleteEnt = payload =>
    AXIOS.post(`/space/enterprise/organization/ent/delete-ent`, payload);

export const addDep = payload =>
    AXIOS.post(`/space/enterprise/organization/ent/add-dep`, payload);

export const deleteDep = payload =>
    AXIOS.post(`/space/enterprise/organization/ent/delete-dep`, payload);

export const rename = payload =>
    AXIOS.post(`/space/enterprise/organization/ent/rename`, payload);

export const memberList = payload =>
    AXIOS.post(`/space/enterprise/organization/member/member-list`, payload);

export const inviteLink = payload =>
    AXIOS.post(`/space/enterprise/organization/member/invite-link`, payload);

export const inviteSave = payload =>
    AXIOS.post(`/space/enterprise/organization/member/invite-save`, payload);

export const deleteMember = payload =>
    AXIOS.post(`/space/enterprise/organization/member/delete`, payload);

export const memberEdit = payload =>
    AXIOS.post(`/space/enterprise/organization/member/edit`, payload);

export const settingPictures = payload =>
    AXIOS.post('/space/enterprise/organization/ent/set-pictures', payload);

// 设置企业信息
export const setEntInformation = payload =>
    AXIOS.post('/space/enterprise/organization/ent/ent-information', payload);

// 获取、设置企业账户
export const getAndSetCorporateBankAccount = payload =>
    AXIOS.post('/space/enterprise/organization/ent/save-bank', payload);

// 交接的数据
export const getHandover = payload =>
    AXIOS.post(
        '/space/enterprise/organization/member/get-project-scheme',
        payload
    );

// 交接+离职
export const postHandover = payload =>
    AXIOS.post('/space/enterprise/organization/member/dimission', payload);
